import * as React from "react";
import {Link} from "react-router-dom";
import {cx} from "emotion";

import "./left-menu-dropdown-products.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {chain}          from "@Common/utils/fs";
import {oMapToArr}      from "@Common/utils/objects";

import {FlexMenuInternalLink} from "../../../common/components/flex-internal-link";

export const lmdProducts = ({navBlock}) => cs(
    consumeContext("themeScheme"),
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    consumeContext("routerHistory"),
    ["catSubStyle", ({catSubStyle}, next) => next(catSubStyle?.value)],
    ["focused", (_, next) => UseState({next})],
    ({catSubStyle, focused, themeScheme, routerHistory}) => (
        <div className="lmd-products-284">
            {catSubStyle && chain(
                oMapToArr(catSubStyle, (v, id) => ({...v, id})),
                (_) => sessionStorage.getItem("listingId") ? _ : _.filter((cat) => !cat.program),
                (_) => _.sort((a, b) => {
                    if ( a.categoryType != "subscriber" && b.categoryType == "subscriber" ) {
                        return 1;
                    }
                    else if ( a.categoryType == "subscriber" && b.categoryType != "subscriber" ) {
                        return -1;
                    }
                    else {
                        return a.seq - b.seq;
                    }
                }),
            ).map((cat) => (
                <div
                    className="cat"
                    key={cat.id}
                >
                    {FlexMenuInternalLink({
                        href: cat.link,
                        to: `/cat/${cat.id}`,
                        className: cx("toggle", {focused: focused.value === cat.id}),
                        style: {color: themeScheme.xpresso.menuTextColor},
                        "xd-qa-type": "link",
                        "xd-qa-name": cat.name,
                        children: cat.name,
                        navBlock,
                    })}

                    {focused.value === cat.id && (
                        cat.child.map((sub) => (
                            <Link
                                to={`/cat/${cat.id}/sub/${sub.id}`}
                                className="sub-cat"
                                key={sub.id}
                                xd-qa-type="link"
                                xd-qa-name={sub.name}
                                onClick={async (e) => {
                                    e.preventDefault();

                                    if (await navBlock?.block() === true) {
                                        return;
                                    }

                                    routerHistory.push(`/cat/${cat.id}/sub/${sub.id}`);
                                }}
                            >
                                {sub.name}
                            </Link>
                        ))
                    )}
                </div>
            ))}

        </div>
    ),
);